export default "__VITE_ASSET__DjlVBA1I__"